<template>
	<div class="myorder">
		<cube-page type="myorder-view" title="商品管理">
			<div slot="content">
				<van-search placeholder="请输入商品名称" v-model="re_value" @search="onSearch" show-action>
					<div slot="action" @click="onSearch" @clear="clearSearch">
						<van-button type="primary" size="small">搜索</van-button>
					</div>
				</van-search>
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<van-list class="leoshop-content" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
						:immediate-check="false">
						<div class="orderitem" v-for="(item, idx) in OrderList" :key="idx">
							<van-card :price="item.goods_price" :title="item.goods_name" :thumb="item.images">
								<template #price-top>
									<div class="ells2 carddesc">
										<span>上架时间：</span>
										<span>{{item.time}}</span>
									</div>
								</template>
								<template #footer>
									<van-button @click="goSjcp(item.goods_id)" plain hairline round size="small" type="primary">修改
									</van-button>
									<van-button @click="showD(item.goods_id,$event)" plain hairline round size="small" type="danger">下架
									</van-button>
									<van-button @click="onShowQrCode(item.goods_id)" :loading="btnloading" loading-text="请稍后..." plain
										hairline round size="small" type="info">商品码
									</van-button>
								</template>
							</van-card>

						</div>
					</van-list>
				</van-pull-refresh>
				<div class="loading" v-show="showLoading">
					<van-loading type="spinner" />
				</div>
			</div>
		</cube-page>
		<cube-view></cube-view>
		<van-popup v-model="qrshow" round>
			<div class="qrshow">
				<van-image :src="qrimg" />
			</div>
		</van-popup>
		<van-loading type="spinner" />
	</div>
</template>

<script>
	import CubeView from '@/components/TP/cube-view'
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		Toast
	} from 'vant';
	import {
		Dialog
	} from 'vant';

	export default {
		components: {
			CubePage,
			CubeView,
		},
		data() {
			return {
				store: null,
				showLoading: false,
				qrshow: false,
				loading: false,
				finished: false,
				OrderList: [],
				active: this.$route.query.showType,
				pageIndex: 1,
				pageTotal: 0,
				qrimg: '',
				btnloading: false,
				re_value: '',
				refreshing: false,
			};
		},
		created() {
			this.store = this.$store.getters.getShop
			this.loadData()
		},
		methods: {
			// 点击搜索触发
			onSearch() {
				if (!this.re_value) {
					return Toast('搜索不能为空')
				}
				this.publicUpdata();
			},
			// 清空搜索框触发
			clearSearch() {
				this.onRefresh();
			},
			// 下拉刷新触发
			onRefresh() {
				this.re_value = '';
				this.publicUpdata();
			},
			// 通用刷新
			publicUpdata() {
				this.finished = false;
				this.OrderList = [];
				this.pageIndex = 1;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.loadData();
			},
			// 触发下拉列表加载
			onLoad() {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.loadData();
				}, 1000)
			},
			// 获取数据
			loadData() {
				var url = "/addons/litestore/api.store/storeProductList"
				let that = this;
				util.post(url, {
						page: that.pageIndex,
						store_id: that.store.id,
						search: that.re_value,
					},
					function(result) {
						if (that.refreshing) {
							that.OrderList = [];
							that.refreshing = false;
						}
						let data = result.data
						that.loading = false;
						if (data.list == null || data.list.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.OrderList = that.OrderList.concat(data.list);
					},
				);
			},
			// 浏览二维码
			onShowQrCode(id) {
				let that = this;
				that.qrimg = ''
				var url = "/addons/litestore/api.store/goodsQrcode"
				util.post(url, {
						store_id: that.store.id,
						goods_id: id
					},
					function(result) {
						that.qrimg = result.data
						that.btnloading = false
						that.qrshow = true
					},
				);
			},
			//修改上架
			goSjcp(id) {
				this.$router.push({
					path: '/sjcpxq',
					query: {
						goods_id: id
					}
				})
			},
			// 下架
			showD(id, event) {
				Dialog.confirm({
						title: '下架操作',
						message: '确认要下架该商品吗？',
					})
					.then(() => {
						this.onConfirm(id, event)
					})
					.catch(() => {
						// on cancel
					});
			},
			onConfirm(id, event) {
				let that = this
				var url = "/addons/litestore/api.store/shelves"
				util.post(url, {
						goods_id: id,
						store_id: that.store.id,
						status: 20
					},
					function(result) {
						Toast('下架成功');
						if (result.code == 1) {
							event.target.parentElement.parentElement.parentElement.remove();
						}
					},
				);
			},
		},
		watch: {
			"$store.state.shop"() {
				this.store = this.$store.getters.getShop
			}
		}
	}
</script>
<style lang="less" scoped="scoped">
	@import url("../../assets/css/order.css");
	@import url("../../assets/css/listboxless.less");

	.loading {
		text-align: center;
	}

	/deep/ .van-search__action {
		line-height: inherit;
	}
</style>
